<template>
  <div class="wrapper">
    <slot v-for="item in tabs" :name="item.name"></slot>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
  },
};
</script>

<style lang="scss">
.wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/idx-tabs/index.vue